import { NgModule } from '@angular/core';
import { RatingToolComponent } from './rating-tool.component';
import { AngularFireAuthGuard, redirectUnauthorizedTo } from '@angular/fire/compat/auth-guard';
import { RouterModule, Routes } from '@angular/router';
import { ScopeGuard } from '@app/shared/guards/scope.guard';
import { AdminScopes } from '@app/shared/services/admin-scopes';
import { ComponentsModule } from '@app/shared/components/components.module';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { FileUploadComponent } from '../../components/file-upload/file-upload.component';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['login']);
const routes: Routes = [
  {
    path: '',
    canActivate: [AngularFireAuthGuard, ScopeGuard],
    data: { scopes: [AdminScopes.VIEW_RATING_TOOL] },
    canActivateChild: [ScopeGuard],
    children: [
      {
        path: '',
        component: RatingToolComponent,
        data: { scopes: [AdminScopes.VIEW_RATING_TOOL], authGuardPipe: redirectUnauthorizedToLogin },
      },
    ],
  },
];

@NgModule({
  imports: [ComponentsModule, CommonModule, RouterModule.forChild(routes), SharedModule, FileUploadComponent],
  exports: [RouterModule],
  declarations: [RatingToolComponent],
})
export class RatingToolModule {}
